import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";

// Simple loading component
function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '24px',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>🎲</div>
        <div>Loading Mokshapatra...</div>
        <div style={{ fontSize: '14px', marginTop: '10px', opacity: 0.8 }}>
          Initializing your spiritual journey
        </div>
      </div>
    </div>
  );
}

// Try to load components with error handling
let App, AuthProvider, ErrorBoundary;

try {
  App = require("./App").default;
  AuthProvider = require("./AuthContext").AuthProvider;
  ErrorBoundary = require("./ErrorBoundary").default;
} catch (error) {
  console.error("Failed to load components:", error);
  
  // Fallback - show error
  const rootElement = document.getElementById("root")!;
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <div style={{ padding: '40px', background: 'white', minHeight: '100vh' }}>
      <h1 style={{ color: 'red' }}>Failed to Load App</h1>
      <p><strong>Error:</strong> {error.toString()}</p>
      <p>This might be a browser compatibility issue.</p>
      <button 
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px',
          background: '#667eea',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Try Again
      </button>
    </div>
  );
  throw error; // Stop execution
}

// If we got here, components loaded successfully
const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<LoadingScreen />}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);

// Log successful load
console.log("✅ Mokshapatra loaded successfully");
